import { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { Alert } from 'react-bootstrap';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

function ModifMdpVerification(props) {
    const [isLoading, setIsLoading] = useState(false); 
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [email, setEmail] = useState('')
    const apiUrl = process.env.REACT_APP_API_URL;
    const recaptcha = useRef()



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); 
        setError(null);
        const captchaValue = recaptcha.current.getValue()

    
        if (email === '' ) {
          setError("Veuillez remplir tous les champs du formulaire.");
          setIsLoading(false);
          return;
        }
        else if (!captchaValue) {
          setError("Veuillez vérifier le captcha");
          setIsLoading(false);
          return;
        }
    
        try {
          const response = await axios.post(`${apiUrl}/reset-mdp/verification-email`, {
            email: email,
            captcha: captchaValue 
          });
    
          setSuccess(response.data.message);
          setError(null);
          setIsLoading(false);
          setEmail('')
    
    
        } catch (error) {
          setIsLoading(false);
          setEmail('')
          if (error.response) {
            
            setError(error.response.data.message);
          } else {
            
            setError(true)
          }
        }
      };





  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    ); 
  }

  return (
    <>
      <Modal show={props.showMdp} onHide={props.showMDPFalse} >
        <Modal.Header closeButton>
          <Modal.Title>Mot de passe oublié</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {error && (
            <Alert key="danger" variant="danger">
                {error}
            </Alert>
        )}
        {success && (
            <Alert key="success" variant="success">
                {success}
            </Alert>
        )}
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Entrer votre adresse mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Form>
          <br/>
          <div className="text-center mb-3">
            <ReCAPTCHA ref={recaptcha} style={{display:'flex', justifyContent : 'center'}} sitekey={process.env.REACT_APP_KEY_CAPTCHA} />
          </div>
          <br/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.showMDPFalse}>
            Annuler
          </Button>
          <Button variant="primary" disabled={success} onClick={e => handleSubmit(e)}style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
            Envoyer
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModifMdpVerification;